import { render } from "./Painting.vue?vue&type=template&id=0c3db57f&scoped=true"
import script from "./Painting.vue?vue&type=script&lang=js"
export * from "./Painting.vue?vue&type=script&lang=js"

import "./Painting.vue?vue&type=style&index=0&id=0c3db57f&lang=scss&scoped=true"

import exportComponent from "/tmp/build_cd2b88ef/app/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c3db57f"]])

export default __exports__